import { translate } from '../../../cls/TranslationContext'

export const recurrenceLabels = {
	deadline: translate('single.deadline'),
	day: translate('single.daily'),
	week: translate('single.weekly'),
	month: translate('single.monthly'),
	year: translate('single.yearly')
}
